export const ACCESS_TOKEN_LS_KEY = 'access_token'

export const SHOW_2FA_PROPOSE_MODAL_LS_KEY = 'show_2fa_propose_modal'

export const OPEN_AUTH_APP_MODAL_QUERY_PARAM = 'openAuthAppModal'
